import { useEffectOnce } from '@hooks/useEffectOnce';
import useFormatter from '@hooks/useFormatter';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useValueState } from '@hooks/useValueState';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { IDespesaRecibo, useDespesaService } from '@services/DespesaService';
import React from 'react';
import { useParams } from 'react-router-dom';

export type DespesaReciboProps = {
}

export interface IDespesaReciboParams {
    id: string
}

export function DespesaRecibo (props: DespesaReciboProps) {
    const formatter = useFormatter();
    const despesaRecibo = useValueState<IDespesaRecibo>();
    
    const cls = useStyles();

    const params = useParams<IDespesaReciboParams>();
    const despesaService = useDespesaService();

    const loading = useLoading();
    const message = useMessage();

    useEffectOnce(() => {
        if (!loading.isLoading) {
            loading.start();
            despesaService.obterRecibo(parseInt(params.id))
                .then(despesaRecibo.handleResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    })

    return loading.isLoading
        ? <CircularProgress size="small" />
        : (
            <div className={cls.box}>
                <div className={cls.title}>Recibo de Pagamento</div>
                <div className={cls.value}>
                    <div className={cls.valueBox}>R$ {formatter.toFloat(despesaRecibo.value?.valor)}#</div>
                </div>

                <div className={cls.body}>
                    Recebi de {despesaRecibo.value?.empresaNome} - CNPJ {despesaRecibo.value?.empresaCnpj} a importância de {despesaRecibo.value?.valorExtenso} referente à {despesaRecibo.value?.referencia}.<br /><br />
                    Para maior clareza firmamos o presente recibo para que produza os seus efeitos, dando plena, rasa e irrevogável quitação pelo valor recebido.
                </div>

                <div className={cls.date}>
                    <div className={cls.dateBox}>{despesaRecibo.value?.cidade}, {despesaRecibo.value?.dia} de {despesaRecibo.value?.mesExtenso} de {despesaRecibo.value?.ano}</div>
                </div>

                <div className={cls.sign}>
                    <div className={cls.signBox}>Assinatura</div>
                </div>
            </div>
        )
}

const useStyles = makeStyles(theme => ({
    box: {
        padding: 20,
        border: '1px solid #ccc',
        width: 600,
        margin: 'auto',
        marginTop: 50
    },

    title: {
        fontSize: '1.2em',
        fontWeight: 'bold',
        textAlign: 'center'
    },

    value: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'flex-end',
    },

    valueBox: {
        border: '2px solid #000',
        padding: 5,
    },

    body: {
    },

    date: {
        marginTop: 25,
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'flex-end',
    },

    dateBox: {
    },

    sign: {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center'
    },

    signBox: {
        width: 300,
        paddingTop: 5,
        borderTop: '1px solid #000'
    }
}));